module.exports = __webpack_public_path__ + "static/media/eats.a1cccca2.jpg";